export default __webpack_public_path__ + "static/media/example-src.9ae0a351.webp";